// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OperacaoServiceOrders_ReprocessosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/operacao_service_orders/reprocessos.
 *
 * Returns the reprocesso volume in the user's filter scope:
 *   - `reprocessos_count`: number of `so_reprocessos` rows whose linked
 *                          order_item belongs to a franchise in scope and
 *                          whose `so_reprocesso_created_at` falls in the
 *                          filter date range.
 *   - `delivered_items_count`: number of delivered items in the same
 *                              scope. Drives the denominator of the rate.
 *   - `reprocesso_rate`: reprocessos_count / max(delivered_items_count, 1),
 *                        as a float in [0, 1]. 0 when there is no delivery.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OperacaoServiceOrders_ReprocessosResponseDados {
reprocessos_count: number
delivered_items_count: number
reprocesso_rate: number
}

export type OperacaoServiceOrders_ReprocessosResponse = ApiResponse<OperacaoServiceOrders_ReprocessosResponseDados>;

registerResponseContract('OperacaoServiceOrders_ReprocessosResponse', {
  reprocessos_count:     { type: 'number',  required: true },
  delivered_items_count: { type: 'number',  required: true },
  reprocesso_rate:       { type: 'number',  required: true },
})
